import { render } from "./UgNumberModal.vue?vue&type=template&id=40249468&scoped=true"
import script from "./UgNumberModal.vue?vue&type=script&lang=js"
export * from "./UgNumberModal.vue?vue&type=script&lang=js"

import "./UgNumberModal.vue?vue&type=style&index=0&id=40249468&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40249468"]])

export default __exports__